import { useTranslation } from 'react-i18next';

interface SchoolBannerProps {
  schoolName: string;
  schoolLogoUrl?: string;
  accentColor?: string;
}

export function SchoolBanner({ schoolName, schoolLogoUrl, accentColor }: SchoolBannerProps) {
  const { t } = useTranslation();
  return (
    <div
      className="w-full py-2 px-4 text-center text-xs font-medium"
      style={{
        background: accentColor ? `${accentColor}15` : '#0B3C5D10',
        color: accentColor || '#0B3C5D',
      }}
    >
      <div className="flex items-center justify-center gap-2">
        {schoolLogoUrl && <img src={schoolLogoUrl} alt={schoolName} className="h-5 w-5 rounded" />}
        <span>{t('school_banner.bienvenue', { name: schoolName })}</span>
      </div>
    </div>
  );
}
